import ChipsAction from './ChipsAction';

export default ChipsAction;
